<template>
  <div style="width: 60%;">
    <md-dialog
      :md-active.sync="visibleCurrentForm"
      :md-close-on-esc="false"
      :md-click-outside-to-close="false"
    >
      <md-dialog-title>Request Insurance Quote</md-dialog-title>

      <md-dialog-content>
        <form @submit.prevent="submitForm" class="insuranceQuoteForm">
          <div class="md-layout-item">
            <validated-text-input
              class="md-layout-item md-size-100"
              label="Policy Holder First Name"
              v-model="form.policy_holder_given_name"
              regex="^[A-Za-z '-]*$"
              :readonly="!!prefilledContactData"
              :disabled="!!prefilledContactData"
              required
            />
          </div>

          <div class="md-layout-item">
            <validated-text-input
              class="md-layout-item md-size-100"
              label="Policy Holder Last Name"
              v-model="form.policy_holder_last_name"
              regex="^[A-Za-z '-]*$"
              :readonly="!!prefilledContactData"
              :disabled="!!prefilledContactData"
              required
            />
          </div>

          <div class="md-layout-item">
            <validated-autocomplete-input
              class="md-layout-item md-small-size-100"
              label="Policy Holder Gender"
              v-model="form.policy_holder_gender"
              :options="options.gender"
              :readonly="!!prefilledContactData"
              :disabled="!!prefilledContactData"
              required
            />
          </div>

          <div class="md-layout-item">
            <validated-text-input
              class="md-layout-item md-size-100"
              label="Policy Holder Email"
              v-model="form.policy_holder_email"
              :readonly="!!prefilledContactData"
              :disabled="!!prefilledContactData"
              melissaCheckType="email"
              required
            />
          </div>

          <div class="md-layout-item">
            <validated-text-input
              class="md-layout-item md-size-100"
              label="Policy Holder Date of Birth"
              :readonly="!!prefilledContactData"
              :disabled="!!prefilledContactData"
              v-model="form.policy_holder_dob"
              required
            />
          </div>

          <div class="md-layout-item">
            <validated-text-input
              class="md-layout-item md-size-100"
              label="Policy Holder Mobile"
              :minLength=6
              :maxLength=15
              melissaCheckType="phone"
              :readonly="!!prefilledContactData"
              :disabled="!!prefilledContactData"
              v-model="form.policy_holder_mobile"
              required
            />
          </div>

          <div class="md-layout-item">
            <validated-text-input
              class="md-layout-item md-size-100"
              label="Street Number"
              :minLength=0
              :maxLength=20
              :readonly="!!prefilledAddressData"
              :disabled="!!prefilledAddressData"
              v-model="form.risk_address_street_number"
              required
            />
          </div>

          <div class="md-layout-item">
            <validated-text-input
              class="md-layout-item md-size-100"
              label="Street Name"
              :minLength=0
              :maxLength=40
              :readonly="!!prefilledAddressData"
              :disabled="!!prefilledAddressData"
              v-model="form.street_name"
              required
            />
          </div>

          <div class="md-layout-item">
            <validated-autocomplete-input
              class="md-layout-item md-small-size-100"
              label="Street Type"
              v-model="form.street_type"
              :readonly="!!prefilledAddressData"
              :disabled="!!prefilledAddressData"
              :options="options.address_street_type"
            />
          </div>

          <div class="md-layout-item">
            <validated-text-input
              class="md-layout-item md-size-100"
              label="Suburb"
              :minLength=0
              :maxLength=20
              :readonly="!!prefilledAddressData"
              :disabled="!!prefilledAddressData"
              v-model="form.risk_address_suburb"
              required
            />
          </div>

          <div class="md-layout-item">
            <validated-autocomplete-input
              class="md-layout-item md-size-100"
              label="State"
              v-model="form.risk_address_state"
              :readonly="!!prefilledAddressData"
              :disabled="!!prefilledAddressData"
              :options="states"
              required
            />
          </div>
          <div class="md-layout-item">
            <validated-text-input
              class="md-layout-item md-size-100"
              label="Post Code"
              v-model="form.risk_address_post_code"
              :readonly="!!prefilledAddressData"
              :disabled="!!prefilledAddressData"
              :minLength=4
              :maxLength=4
              regex="(^\d+$)"
              required
            />
          </div>

          <div class="md-layout-item">
            <validated-autocomplete-input
              class="md-layout-item md-size-100"
              label="Finance Type"
              v-model="form.finance_type"
              :options="finance_type"
              required
            />
          </div>

          <div class="md-layout-item">
            <validated-text-input
              class="md-layout-item md-size-100"
              label="Finance Provider"
              v-model="form.finance_provider"
              required
            />
          </div>

          <div class="md-layout-item">
            <validated-text-input
              class="md-layout-item md-size-100"
              label="Vehicle NVIC"
              v-model="form.vehicle_nvic"
              alpha-num
              required
            />
          </div>

          <div class="md-layout-item">
            <validated-text-input
              class="md-layout-item md-size-100"
              label="Vehicle Rego"
              v-model="form.vehicle_rego"
              alpha-num
            />
          </div>

          <div  class="md-layout-item">
              <md-field>
              <label for="parent_id">Estimated annual kms</label>
              <md-select
                v-model="form.kms_estimated"
                name="kms_estimated"
                id="kms_estimated"
              >
              <md-option :value="null" disabled>Select estimated kms</md-option>
              <md-option
                v-for="option in kmsOptions"
                :key="option.value"
                :value="option.value"
              >
                {{ option.text }}
              </md-option>
            </md-select>
          </md-field>
          </div>
        </form>
      </md-dialog-content>

      <md-dialog-actions>
        <loading-icon-text-button
          class="md-primary"
          :loading="loading"
          @click="onSubmit">
          Submit
        </loading-icon-text-button>
        <md-button class="md-accent" @click="onCancel">Cancel</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog-alert
      :md-active.sync="error_alert.show"
      :md-content="error_alert.message"
      md-confirm-text="Close"
    />
    <InsuranceQuoteModal
      :visible="showQuoteModal"
      :quoteMetadata="quoteMetadata"
      @close="showQuoteModal = false" />
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import ValidatedInputs from "@/components/ValidatedInput";
import AlertDialog from "@/components/Dialogs/AlertDialog";
import ConfirmDialog from "@/components/Dialogs/ConfirmDialog";
import LoadingIconTextButton from "@/components/LoadingIconTextButton";
import InsuranceQuoteModal from "../Modals/InsuranceQuoteModal.vue";

export default {
  components:{
    LoadingIconTextButton,
    ...ValidatedInputs,
    ConfirmDialog,
    AlertDialog,
    InsuranceQuoteModal
  },
  data() {
    return {
      visibleCurrentForm: false,
      form: {
        policy_holder_given_name: "",
        policy_holder_last_name: "",
        policy_holder_email: "",
        policy_holder_dob: "",
        policy_holder_mobile: "",
        risk_address_street_number: "",
        risk_address_street_name: "",
        risk_address_suburb: "",
        risk_address_state: "",
        risk_address_post_code: "",
        finance_type: "Loan Secured",
        finance_provider: "",
        vehicle_nvic: "",
        vehicle_rego: "",
        kms_estimated: "",
      },
      error_alert:{
        show: false,
        message:''
      },
      kmsOptions: Array.from({ length: 50 }, (_, i) => {
        const value = (i + 1) * 1000;
        return { text: `${value.toLocaleString()} kms`, value };
      }),
      prefilledContactData: false,
      prefilledAddressData: false,
      showQuoteModal: false,
      loading: false,
      quoteMetadata: null,
    };
  },
  props: {
    visible: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters([
      'application',
      "options",
    ]),
    states() {
      let country = this.options.countries && this.options.countries[0] || null;
      return this.options.country_states[country];
    },
    finance_type() {
      return [
        'None',
        'Lease/Hire Purchase',
        'Loan Secured',
        'Loan Unsecured'
      ];
  }
  },
  methods: {
    validateForm() {
      let isValid = true;

      const requiredFields = [
        "policy_holder_given_name",
        "policy_holder_last_name",
        "policy_holder_gender",
        "policy_holder_email",
        "policy_holder_dob",
        "policy_holder_mobile",
        "risk_address_street_number",
        "street_name",
        "street_type",
        "risk_address_suburb",
        "risk_address_state",
        "risk_address_post_code",
        "vehicle_nvic",
        "kms_estimated",
      ];

      for (let field of requiredFields) {
        if (!this.form[field] || this.form[field].toString().trim() === "") {
          this.showErrorDialog(`Please fill in the ${field.replace(/_/g, " ")} field.`, true);
          isValid = false;
          break;
        }
      }
      if (!this.form.policy_holder_dob.match(/^\d{2}-\d{2}-\d{4}$/)) {
        this.showErrorDialog(`Date must be in DD-MM-YYYY format.`, true);
        isValid = false;
      }

      return isValid;
    },
    async onSubmit() {
      if (!this.validateForm()) {
        return;
      }

      const res = await this.showNotification(
        "Confirm",
        "This will request a new insurance quote. Continue?",
        "Confirm",
        "Cancel"
      );
      if (!res) {
        return;
      }

      this.loading = true;
      //Payload update
      this.form.risk_address_street_name =
        [this.form.street_name, this.form.street_type].filter(Boolean).join(" ") || "";
      this.kms_estimated = parseInt(this.kms_estimated) || 0;
      this.form.policy_holder_gender = this.formatGender(this.form.policy_holder_gender);
      this.form.finance_type = this.formatFinanceType(this.form.finance_type);
      try {
        const response = await axios.post("/api/v1/application/generateInsuranceQuote", this.form);
        this.quoteMetadata = response.data?.payload;
        await this.$store.dispatch("reload_application");
        this.loading = false;
        await this.showNotification("",
          "Insurance quote request sent successfully!",
          "OK"
        )
        this.visibleCurrentForm = false;
        this.showQuoteModal = true;
      } catch (error) {
        this.loading = false;
        let errorMessage = error?.response?.data?.error?.error?.msg;
        this.showNotification("Error generating insurance quote",
          (error.response?.data?.message || error.message) + ". Error: " + errorMessage,
          "OK"
        )
        console.error("Error generating insurance quote:", error.response?.data);
      }
    },
    onCancel() {
      this.visibleCurrentForm = false;
      this.$emit("close");
    },
    showErrorDialog(message, flag){
      this.error_alert=
      {
        message: message,
          show: flag
      };
    },
    showNotification(title, message, confirmText, cancelText = null) {
      return this.$modal.show(ConfirmDialog, {
        title,
        message,
        confirmText,
        cancelText
      })
    },
    calculateAge(dob) {
      const birthDate = new Date(dob);
      const today = new Date();

      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      const dayDiff = today.getDate() - birthDate.getDate();

      // Adjust age if birthday hasn't occurred yet this year
      if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
          age--;
      }

      return age;
    },
    getLicenseCode(licenseDescription) {
      const reverseLicenseMap = {
        "Learner": "learner",
        "Provisional 1": "p1",
        "Provisional 2": "p2",
        "Open": "full",
        "Probationary": "unknown"
      };

      return reverseLicenseMap[licenseDescription] || "unknown";
    },
    formatGender(value) {
      const gender = value?.toString().toUpperCase();
      return gender === 'MALE' || gender === 'FEMALE' ? gender : '';
    },
    formatFinanceType(value) {
      if (!value || typeof value !== 'string') return '';
      return value.toLowerCase().replace(/[\s/]+/g, '_');
    },
    resetForm() {
      if (this.application) {
        this.form.loan_application_id = this.application?.loan?.id;
        let contactData = this.application?.applicants?.[0]?.contact || {};
        this.prefilledContactData = contactData && Object.keys(contactData).length > 0;
        let vehicleData = this.application?.loan?.asset?.vehicle || {};
        this.form.policy_holder_given_name = contactData.name?.firstname || "";
        this.form.policy_holder_last_name = contactData.name?.lastname || "";
        this.form.policy_holder_email = contactData.emails?.[0]?.email || "";
        const dateOfBirth = new Date(contactData.date_of_birth);
        this.form.policy_holder_dob = dateOfBirth.toLocaleDateString('en-GB').replace(/\//g, '-');
        this.form.policy_holder_licence_age = this.calculateAge(contactData.date_of_birth);
        this.form.policy_holder_mobile = contactData.phones?.[0]?.phone_number || "";
        const gender = contactData.gender?.toLowerCase();
        this.form.policy_holder_gender = gender === 'male' ? 'Male'
        : gender === 'female' ? 'Female'
        : '';
        let licenseType = this.application?.applicants?.[0]?.personal_details?.indentifications?.[0]?.license_type;
        let mappedLicenseType = this.getLicenseCode(licenseType);
        if (mappedLicenseType !== 'unknown') {
          this.form.policy_holder_licence_type = mappedLicenseType;
        }

        let currentAddress = this.application?.applicants?.[0]?.addresses?.current?.address || {};
        this.prefilledAddressData = currentAddress && Object.keys(currentAddress).length > 0;
        this.form.risk_address_street_number = currentAddress.street_number || "";
        this.form.street_name = currentAddress.street_name || "";
        this.form.street_type = currentAddress.street_type || "";
        this.form.risk_address_street_number = currentAddress.street_number || "";
        this.form.risk_address_suburb = currentAddress.suburb || "";
        this.form.risk_address_state = currentAddress.state || "";
        this.form.risk_address_post_code = currentAddress.post_code || "";
        this.form.vehicle_nvic = vehicleData.nvic || "";
        this.form.vehicle_rego = vehicleData.registration || "";

        this.form.finance_provider = this.application?.loan?.submission?.active?.product?.lender_name || "";
      }
    }
  },
  created() {
    this.resetForm()
  },
  watch: {
    visible (value) {
      this.visibleCurrentForm = value;

      if (value) {
        this.resetForm();
      }
    },
  },
  async beforeCreate() {
    const params = {
      types: [
        'address_street_type',
        'gender'
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
};
</script>

<style scoped>
/* Override default md-dialog width for better layout */
.insuranceQuoteForm {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
</style>
